import { useFitAllButton } from '../MapControls/useFitAllButton';
import { useMapContext } from '@hero/web-context';

/**
 * FitAllButtonHandler - Handles the Fit All button without showing the MapControls container
 * Uses MapContext as the single source of truth for map, locations, and fitBounds
 */
export function FitAllButtonHandler() {
  const ctx = useMapContext();

  useFitAllButton({
    map: ctx.map || null,
    locations: ctx.locations,
    onFitBounds: ctx.fitBounds,
    visible: ctx.showFitAllButton,
    position: google.maps.ControlPosition.RIGHT_BOTTOM,
  });

  return null; // This component doesn't render anything, it just uses the hook
}
